// Analytics/TabContent.jsx
import React from 'react';
import { Typography } from '@mui/material';
import OutpatientsTab from './tabs/OutpatientsTab';
import { IDepartment } from '../../../constants/types';
import InpatientsTab from './tabs/InpatientsTab';
import LabTab from './tabs/LabTab';
import RadiologyTab from './tabs/RadiologyTab';
import FinancesTab from './tabs/FinancesTab';

interface TabContentProps {
  activeTabId: string;
  loading: boolean;
  startDate: string;
  endDate: string;
  investigation: {
    permissions: string[];
    [key: string]: any;
  };
  departmentSelected: string;
  departments: IDepartment[];
}

const TabContent: React.FC<TabContentProps> = ({
  activeTabId,
  loading,
  startDate,
  endDate,
  investigation,
  departmentSelected,
  departments
}) => {
  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  const commonProps = {
    investigation,
    departmentSelected,
    startDate,
    endDate,
    departments,
    tabNumber: 0,
  };

  switch (activeTabId) {
    case 'outpatients':
      return <OutpatientsTab {...commonProps} />;
    case 'inpatients':
      return <InpatientsTab {...commonProps} />;
    case 'laboratory':
      return <LabTab {...commonProps} />;
    case 'radiology':
      return <RadiologyTab {...commonProps} />;
    case 'finances':
      return <FinancesTab {...commonProps} />;
    default:
      return <Typography>No data available for this tab.</Typography>;
  }
};

export default TabContent;
